import {
  POPULATE_MEETING_SETTINGS,
  POPULATE_AVAILABILITIES,
  POPULATE_MEETINGS,
  POPULATE_ATTENDEE_MEETINGS,
  POPULATE_MEETING_DETAILS,
} from './constants';

const initialState = {
  meetingSettings: undefined,
  availabilities: undefined,
  meetings: undefined,
  attendeeMeetings: undefined,
  meetingDetails: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case POPULATE_MEETING_SETTINGS:
      return {
        ...state,
        meetingSettings: action.meetingSettings || {},
      };
    case POPULATE_AVAILABILITIES:
      return {
        ...state,
        availabilities: action.availabilities || [],
      };
    case POPULATE_MEETINGS:
      return {
        ...state,
        meetings: action.meetings || [],
      };
    case POPULATE_ATTENDEE_MEETINGS:
      return {
        ...state,
        attendeeMeetings: action.attendeeMeetings || [],
      };
    case POPULATE_MEETING_DETAILS:
      return {
        ...state,
        meetingDetails: action.meetingDetails || {},
      };
    default:
      return state;
  }
};
